/**
 * Migrates the summary language in the response object. If the
 * `summaryLanguage` property exists in the `agent_copilot` object, it's value
 * will be copied to the `preferredLanguage` property, then set to `undefined`.
 */
export function migrateAgentCopilotSummaryLanguage(response: any): any {
  const oldSummaryLanguage = response['agent_copilot']?.summaryLanguage;
  if (oldSummaryLanguage) {
    response['agent_copilot'].preferredLanguage = oldSummaryLanguage;
    response['agent_copilot'].summaryLanguage = undefined;
  }
  return response;
}
